import { $gettext } from '@/services/translations'

const EMPLOYEE = 'EMPLOYEE'
const CUSTOMER_OR_CLIENT = 'CUSTOMER_OR_CLIENT'
const IN_HONOR_OR_MEMORY_OF = 'IN_HONOR_OR_MEMORY_OF'
const OTHER = 'OTHER'
const ORG_RELATIONSHIP_CHOICES = [
  { label: $gettext('Employee'), value: EMPLOYEE },
  { label: $gettext('Customer/client'), value: CUSTOMER_OR_CLIENT },
  { label: $gettext('Other partner or stakeholder'), value: OTHER },
  { label: $gettext('In honor or memory of'), value: IN_HONOR_OR_MEMORY_OF },
]

export default {
  EMPLOYEE,
  CUSTOMER_OR_CLIENT,
  IN_HONOR_OR_MEMORY_OF,
  OTHER,
  ORG_RELATIONSHIP_CHOICES,
}
